var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "15",
        viewBox: "0 0 18 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.7 1.51807C2.7 0.964941 3.10219 0.518066 3.6 0.518066H12.6H14.4C16.3884 0.518066 18 2.30869 18 4.51807C18 6.72744 16.3884 8.51807 14.4 8.51807H13.5C13.5 10.1743 12.2906 11.5181 10.8 11.5181H5.4C3.90937 11.5181 2.7 10.1743 2.7 8.51807V1.51807ZM13.5 6.51807H14.4C15.3928 6.51807 16.2 5.62119 16.2 4.51807C16.2 3.41494 15.3928 2.51807 14.4 2.51807H13.5V6.51807ZM0.9 12.5181H15.3C15.7978 12.5181 16.2 12.9649 16.2 13.5181C16.2 14.0712 15.7978 14.5181 15.3 14.5181H0.9C0.402187 14.5181 0 14.0712 0 13.5181C0 12.9649 0.402187 12.5181 0.9 12.5181Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }